import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.15.4_@azure+cosmos@4.4.1_@azure+identity@4.10.0_@parcel+watcher@2.5.1_@types+node@22.1_esv4ofspemqqh2ucwojjfu7szq/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}